import { Box, Text } from '@wix/design-system';
import React from 'react';
export const RuleDescription = _ref => {
  let {
    children,
    dataHook
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2"
  }, /*#__PURE__*/React.createElement(Text, {
    dataHook: dataHook,
    size: "tiny",
    weight: "thin",
    secondary: true
  }, children));
};
//# sourceMappingURL=rule-description.js.map